import { Box } from '@mui/material';
import * as R from 'ramda';
import useWidth from '../../../../../components/Hooks/useWidth';
import MoneyRendererV3 from '../../../../../components/Money/MoneyRendererV3/MoneyRendererV3';
import Typography from '../../../../../components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import MarkupChip from '../../../MarkupChip';
import { RetailPriceSectionProps } from '../interfaces/retailPriceSection.interfaces';
import RetailPriceSectionMobile from './RetailPriceSectionMobile';

const RetailPriceSection = ({
  hasRetailPriceVariation,
  minMaxRetailPrice,
  showMarkup,
  markup,
}: RetailPriceSectionProps) => {
  const { translate } = useTranslation();
  const { mobileWidth } = useWidth();
  if (R.isNil(minMaxRetailPrice.min) || R.isNil(minMaxRetailPrice.max)) {
    return null;
  }

  if (mobileWidth) {
    return (
      <RetailPriceSectionMobile
        markup={markup}
        showMarkup={showMarkup}
        hasRetailPriceVariation={hasRetailPriceVariation}
        retailPriceRange={{ min: minMaxRetailPrice.min, max: minMaxRetailPrice.max }}
      />
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        columnGap: '16px',
      }}
    >
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(3 / 4),
        })}
      >
        {hasRetailPriceVariation && (
          <>
            <MoneyRendererV3 value={minMaxRetailPrice?.min} color="textSecondary" />
            <Typography variant="body1">-</Typography>
          </>
        )}
        <MoneyRendererV3 value={minMaxRetailPrice?.max} color="textSecondary" />
        <Typography variant="body2" color="textSecondary">
          {translate(LangEnum.GLOBAL_SUGGESTED_SINGULAR)}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {showMarkup && markup && (
          <MarkupChip markupValue={markup} markupTextInLabel fontSize={12} />
        )}
      </Box>
    </Box>
  );
};

export default RetailPriceSection;
